<template>
  <div class="submission-cases">
    <div class="pogs-list--panels__header">
      <label>Case No</label>
      <label>Patient Name</label>
      <label>Admission Date</label>
      <label>Discharge Date</label>
    </div>
    <div class="pogs-list--panels compact">
      <div class="pogs-list__item"
           v-for="(c, key) in packagedCases"
           :key="key"
           @click="showCaseForm(c._id, c.patientid._id)">

        <div><h3>{{c.caseNum}}</h3></div>
        <div>{{c.patientid.lastName}}, {{c.patientid.firstName}} {{c.patientid.middleName}}</div>
        <div>{{c.admissionDate | formatDate}}</div>
        <div>{{c.dischargeDate | formatDate}}</div>

      </div>
    </div>
  </div>
</template>

<script>
  import Routes from '../../../../router/route-constants'
  import uihelper from "../../../../mixins/uihelper";

  export default {
    mixins: [uihelper],
    props:{
      packagedCases: {},
      dates: ''
    },
    methods: {
      showCaseForm(caseid, patientid){
        const params = {caseid, patientid};
        this.$router.push({
          name: Routes.ROUTE_EDIT_PATIENT_CASE,
          params: params
        })
      }
    }
  }
</script>
